import i18next from 'i18next';
import type { VehiclePurchaseInfoType } from '../../../../../../data/vehicles/useVehicle';
import Badge from '../../../../../../styled-components/components/Badge';

export const purchaseInfoTypesLabel = (type: VehiclePurchaseInfoType) => {
  switch (type) {
    case 'urn:wayke:vehicle:purchase-type:build-to-order':
      return i18next.t('shared.purchaseInfo.types.buildToOrder', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:purchase-type:trade-in':
      return i18next.t('shared.purchaseInfo.types.tradeIn', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:purchase-type:workshop':
      return i18next.t('shared.purchaseInfo.types.workshop', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:purchase-type:rental':
      return i18next.t('shared.purchaseInfo.types.rental', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:purchase-type:leasing':
      return i18next.t('shared.purchaseInfo.types.leasing', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:purchase-type:import':
      return i18next.t('shared.purchaseInfo.types.import', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:purchase-type:brokerage':
      return i18next.t('shared.purchaseInfo.types.brokerage', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:purchase-type:demo':
      return i18next.t('shared.purchaseInfo.types.demo', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    case 'urn:wayke:vehicle:purchase-type:direct-purchase':
      return i18next.t('shared.purchaseInfo.types.directPurchase', {
        ns: 'salesAndPurchasingVehiclesItem',
      });
    default:
      return '–';
  }
};

interface PurchaseInfoTypesBadgeProps {
  type: VehiclePurchaseInfoType;
}

export const PurchaseInfoTypesBadge = ({ type }: PurchaseInfoTypesBadgeProps) => (
  <Badge tone="contrast">{purchaseInfoTypesLabel(type)}</Badge>
);
